export default __webpack_public_path__ + "static/media/ge3.7cf0848f.jpg";